<template>
  <div v-if="isEntrega">
    <v-row dense>
      <v-col cols="12" sm="6" md="7">
        <p class="mb-1">
          <span class="title font-weight-bold text--primary">
            {{ finalizacao.locaisEntrega.nomeLocal }}
          </span>
        </p>
      </v-col>
    </v-row>
    <p>
      <v-icon>mdi-map-marker</v-icon>
      {{ finalizacao.locaisEntrega.endereco | endereco }}
    </p>
  </div>
  <div v-else>
    <v-row dense>
      <v-col cols="12" sm="6" md="7">
        <p class="mb-1">
              <span class="title font-weight-bold text--primary">
                {{ finalizacao.comprador.pessoa.nome }}
              </span>
        </p>
      </v-col>
    </v-row>
    <p class="mt-2">
      <v-icon>mdi-domain</v-icon>
      {{ finalizacao.comprador.pessoa.cnpj | cpfCnpj }}
    </p>
    <p>
      <v-icon>mdi-map-marker</v-icon>
      {{ finalizacao.comprador.endereco | endereco }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    finalizacao: Object,
    isEntrega: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
